export default __webpack_public_path__ + "static/top-25-2020-8197010f2a615e688b0553b51aa51f36.png";